<template>
  <LineChartGenerator :data="chartData" :options="options" />
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);

export default {
  name: "BudgetMonthlyLineChart",
  components: { LineChartGenerator },
  props: {
    labels: { type: Array, required: true },
    budgetData: { type: Array, required: true },
    actualData: { type: Array, required: true },
  },
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: "Budget",
            data: this.budgetData,
            fill: false,
            borderColor: "#018673",
            backgroundColor: "#018673",
            borderWidth: 2,
            tension: 0.2,
          },
          {
            label: "Actual",
            data: this.actualData,
            fill: false,
            borderColor: "#1d4ed8",
            backgroundColor: "#1d4ed8",
            borderWidth: 2,
            tension: 0.2,
          },
        ],
      };
    },
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: true },
          tooltip: { enabled: true },
          title: { display: false },
        },
        scales: {
          y: { beginAtZero: true },
        },
      };
    },
  },
};
</script>

